module.exports = __webpack_public_path__ + "img/sankaku_58_blue.de5a41f3.png";